import ExternalLink from 'components/UI/ExternalLink'
import FeaturePageSkeleton from 'components/features-page/FeaturePageSkeleton'
import { graphql } from 'gatsby'
import { ReactElement } from 'react'
import { Text } from 'theme-ui'
import getEnglishStrings from 'utils/getEnglishStrings'
import { useFeaturePageSlug } from 'utils/useFeaturePageSlug'

export default function SplitPersonality({
  data,
}: {
  data: Queries.SplitPersonalityPageQuery
}): ReactElement {
  const splitPersonalityData = getEnglishStrings(data.directus.split_personality?.strings)
  const generalTranslationsData = getEnglishStrings(data.directus.general_translations?.strings)
  const queryParam = useFeaturePageSlug()
  return (
    <FeaturePageSkeleton
      metaDescription={splitPersonalityData?.meta_description || ''}
      metaKeywords={splitPersonalityData?.meta_keywords || []}
      title={splitPersonalityData?.title || ''}
      subtitle={splitPersonalityData?.subtitle || ''}
      gridItems={[
        {
          title: splitPersonalityData?.what_is_a || '',
          description: splitPersonalityData?.what_is_a_subtitle || '',
        },
        {
          title: splitPersonalityData?.mix_it_up || '',
          description: splitPersonalityData?.mix_it_up_subtitle || '',
        },
      ]}
      cta={
        <ExternalLink variant="buttons.neon" href={`/download?${queryParam}`}>
          <Text>{splitPersonalityData?.cta}</Text>
        </ExternalLink>
      }
      aboutTheFeature={[
        {
          title: generalTranslationsData?.by_the_way || '',
          items: [splitPersonalityData?.keep_in_mind || ''],
        },
      ]}
    />
  )
}

export const data = graphql`
  query SplitPersonalityPage {
    directus {
      general_translations {
        strings {
          languages_code {
            code
          }
          by_the_way
        }
      }
      split_personality {
        strings {
          languages_code {
            code
          }
          meta_description
          meta_keywords
          mix_it_up
          mix_it_up_subtitle
          subtitle
          title
          what_is_a
          what_is_a_subtitle
          cta
          keep_in_mind
        }
      }
    }
  }
`
